import { render } from "./EmployeeIdCard.vue?vue&type=template&id=5dc6be14"
import script from "./EmployeeIdCard.vue?vue&type=script&lang=js"
export * from "./EmployeeIdCard.vue?vue&type=script&lang=js"

import "./EmployeeIdCard.vue?vue&type=style&index=0&id=5dc6be14&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__